// extracted by mini-css-extract-plugin
export default {"mpBucketPane":"mp-bucket-pane__Rxxx6YHs","inputPane":"input-pane__wi6xGHZF","mpBucketPaneBtn":"mp-bucket-pane-btn__df3cFvz6"};